import { useTheme } from '@emotion/react';
import { Grid, Box, SvgIconTypeMap, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';


export interface IconContent {
  title?: string,
  description?: string,
}

export interface IconText {
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  iconStyles?: Record<string, any>;
  content: IconContent;
}

interface IconItemProps {
  iconContents: IconText[];
  iconColor?: string;
  textColor?: string;
}

const IconItem = (
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>,
  content: IconContent,
  theme: any,
  iconStyles?: Record<string, any>,
  iconColor?: string,
  textColor?: string,
) => (
  <Box textAlign="center" p={1.5} sx={{ color: textColor ?? theme.palette.text.primary }}>
    <Box mb={0.5} display="flex" justifyContent="center">
      <Icon style={{ fontSize: 60, color: iconColor ?? theme.palette.primary.main, ...iconStyles }} />
    </Box>
    {content.title && (
      <Typography variant="h5" gutterBottom sx={{ color: textColor ?? theme.palette.text.primary }}>
        {content.title}
      </Typography>
    )}
    {content.description && (
      <Typography variant="body1" sx={{ color: textColor ?? theme.palette.text.primary }}>
        {content.description}
      </Typography>
    )}
  </Box>
);

const IcontTextXColumns = ({ iconContents, iconColor, textColor }: IconItemProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={3}>
      {iconContents.map((item, i) => (
        <Grid key={i} item xs={12} sm={6} md={Math.floor(12 / iconContents.length)}>
          {IconItem(item.icon, item.content, theme, item.iconStyles, iconColor, textColor)}
        </Grid>
      ))}
    </Grid>
  );
};

export default IcontTextXColumns;
